import {IDirective} from "angular";
import {regNavn} from "../tjenester/tredjepartsTjenestenavn";

export function lasterKnappContainerForInjisering() {
    return [lasterKnappContainer]
}

/*
 * Kommunikasjon mellom lasterKnapp direktiver i samme container som dette direktivet.
 */
export function lasterKnappContainer(): IDirective {
    return {
        restrict: 'A',
        controller: [regNavn.ng.$scope, function ($scope) {
            // @ts-ignore
            this.laster = () => {
                $scope.$broadcast("laster");
            };

            // @ts-ignore
            this.ferdigLastet = () => {
                $scope.$broadcast("ferdigLastet");
            }
        }]
    };
}
